// These variables are written in by Webpack
import {TFunction} from 'i18next';
import {TrainIcon} from 'components/apps/cemitAppComponents/svgIconComponents/sidebar/trainIcon.tsx';
import {TrafficSimIcon} from 'components/apps/cemitAppComponents/svgIconComponents/sidebar/trafficSimIcon.tsx';
import {SoftprioIcon} from 'components/apps/cemitAppComponents/svgIconComponents/sidebar/softprioIcon.tsx';
import {RailIcon} from 'components/apps/cemitAppComponents/svgIconComponents/sidebar/railIcon.tsx';
import {CatenaryIcon} from 'components/apps/cemitAppComponents/svgIconComponents/sidebar/catenaryIcon.tsx';
import {StationIcon} from 'components/apps/cemitAppComponents/svgIconComponents/sidebar/stationIcon.tsx';
import {GrpsIcon} from 'components/apps/cemitAppComponents/svgIconComponents/sidebar/grpsIcon.tsx';
import {DepotIcon} from 'components/apps/cemitAppComponents/svgIconComponents/sidebar/depotIcon.tsx';
import {EventIcon} from 'components/apps/cemitAppComponents/svgIconComponents/sidebar/eventIcon.tsx';
import {BudgetIcon} from 'components/apps/cemitAppComponents/svgIconComponents/sidebar/budgetIcon.tsx';
import ProfileIcon from '../../components/apps/cemitAppComponents/svgIconComponents/sidebar/profileIcon.tsx';
import {SvgProps} from 'components/apps/cemitAppComponents/svgIconComponents/sidebar/SvgProps.ts';
import {AppSettings} from './appSettings.ts';
import {SwitchIcon} from 'components/apps/cemitAppComponents/svgIconComponents/sidebar/switchIcon.tsx';
import {CemitTypename} from 'types/cemitTypename.ts';
import {ApplicationNavigation} from 'types/navigation/applicationNavigation';
import {clsOrTypes} from 'appUtils/typeUtils/clsOrTypes.ts';

/**
 * Creates a list of TabNavigation items representing the possible Visualizer applications
 *
 * See also trafficSimPages/auth/utils.ts for application access control.
 *
 * @param t Used for translation
 * @returns The TabNavigation items
 */
export const applicationNavigationConfig = (
  t: TFunction,
): {
  name: string;
  to: string;
  routeRegex: RegExp;
  Icon: ({fill, stroke}: SvgProps) => JSX.Element;
  accessKey: string;
}[] => {
  const appsPath = AppSettings.appsPath;

  return clsOrTypes<ApplicationNavigation>(CemitTypename.applicationNavigation, [
    // comment r
    // {
    //   accessKey: 'train',
    //   name: t('train'),
    //   to: `/${appsPath}/train/overview`,
    //   routeRegexp: new RegExp(`/${appsPath}/train(/.*)?$`),
    //   Icon: TrainIcon,
    //   isVisible:
    //     process.env.REACT_FEATURE_TRAIN === 'true' ||
    //     process.env.REACT_FEATURE_MENU_TRAIN === 'true',
    //   isEnabled: process.env.REACT_FEATURE_TRAIN === 'true',
    // },

    {
      accessKey: 'tracksim',
      name: t('trafficsim'),
      to: `/${appsPath}/trafficsim/overview`,
      routeRegexp: new RegExp(`/${appsPath}/trafficsim(/.*)?$`),
      Icon: TrafficSimIcon,
      isHiddenWithoutAccessKey: false,
      isVisible:
        process.env.REACT_FEATURE_TRACK_SIM === 'true' ||
        process.env.REACT_FEATURE_MENU_TRACK_SIM === 'true',
      isEnabled: process.env.REACT_FEATURE_TRACK_SIM === 'true',
    },
    {
      accessKey: 'softprio',
      name: t('softprio'),
      to: `/${appsPath}/softprio/overview`,
      routeRegexp: new RegExp(`/${appsPath}/softprio(/.*)?$`),
      Icon: SoftprioIcon,
      isHiddenWithoutAccessKey: false,
      isVisible:
        process.env.REACT_FEATURE_SOFTPRIO === 'true' ||
        process.env.REACT_FEATURE_MENU_SOFTPRIO === 'true',
      isEnabled: process.env.REACT_FEATURE_SOFTPRIO === 'true',
    },
    // {
    //   accessKey: 'switch',
    //   name: t('switch'),
    //   to: `/${appsPath}/switch/overview`,
    //   routeRegexp: new RegExp(`/${appsPath}/switch(/.*)?$`),
    //   Icon: SwitchIcon,
    //   isHiddenWithoutAccessKey: false,
    //   isVisible:
    //     process.env.REACT_FEATURE_SWITCH === 'true' ||
    //     process.env.REACT_FEATURE_MENU_SWITCH === 'true',
    //   isEnabled: process.env.REACT_FEATURE_SWITCH === 'true',
    // },
    // {
    {
      accessKey: null,
      name: t('profile'),
      to: `/profile`,
      routeRegexp: new RegExp(`/profile(/.*)?$`),
      Icon: ProfileIcon,
      isVisible:
        process.env.REACT_FEATURE_PROFILE === undefined ||
        process.env.REACT_FEATURE_PROFILE === 'true' ||
        process.env.REACT_FEATURE_MENU_PROFILE === 'true',
      isEnabled:
        process.env.REACT_FEATURE_PROFILE === undefined ||
        process.env.REACT_FEATURE_PROFILE === 'true',
    },
  ]);
};
